import { Box, styled } from '@mui/material';
import React, { useState } from 'react';
import Carousel from 'react-material-ui-carousel';

import { AnalyticsEvent, useAnalytics } from '../Providers/AnalyticsProvider';
import AcceptableUse from './AcceptableUse';
import Announcements from './Announcements';
import FeatureHighlights from './FeatureHighlights';
import Trainings from './Trainings';

const slides = [
  <Announcements key={'announcements'} />,
  <Trainings key={'trainings'} />,
  <FeatureHighlights key={'feature_highlights'} />,
  <AcceptableUse key={'ai_acceptable_use'} />,
];

const InfoCard = styled(Box)(() => {
  return {
    backgroundColor: 'white',
    minHeight: '300px',
    textAlign: 'start',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '0',
    marginLeft: '0',
    maxHeight: '300px',
    borderRadius: '8px',
    paddingBlock: '5px',
    transition: 'margin 0.2s ease-in-out, padding 0.2s ease-in-out', // Smooth transition effect
  };
});

const CarouselViewer = (): JSX.Element => {
  const [sliding, setSliding] = useState<boolean>(false);
  const analytics = useAnalytics();

  return (
    <div className="ignore-position">
      <Box
        sx={{
          position: 'static',
          overflow: 'hidden',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
        }}
      >
        <Carousel
          autoPlay={false}
          animation="slide"
          navButtonsAlwaysVisible
          indicators
          swipe={false}
          duration={1000}
          interval={10000}
          navButtonsProps={{
            style: {
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              color: '#000',
            },
          }}
          indicatorContainerProps={{
            style: {
              position: 'absolute',
              bottom: '16px',
              zIndex: 1,
              marginTop: 0,
            },
          }}
          indicatorIconButtonProps={{
            style: {
              padding: '3px',
              color: '#070154',
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              color: '#0047FF',
            },
          }}
          sx={{
            minWidth: '500px',
            borderRadius: '8px',
          }}
          next={(now) => {
            setSliding(true);
            analytics.event(
              AnalyticsEvent.WM_NIGEL_CAROUSEL_NAVIGATION_NEXT,
              {
                value: now?.toString(),
              },
              { nextSlide: now }
            );
            setTimeout(() => setSliding(false), 1000);
          }}
          prev={(now) => {
            setSliding(true);
            analytics.event(
              AnalyticsEvent.WM_NIGEL_CAROUSEL_NAVIGATION_PREV,
              {
                value: now?.toString(),
              },
              { prevSlide: now }
            );
            setTimeout(() => setSliding(false), 1000);
          }}
        >
          {slides.map((slide, index) => (
            <InfoCard
              key={index}
              sx={{
                bgcolor: '#E8EEF8',
                marginX: sliding ? '5px' : '0px',
                paddingInline: sliding ? '45px' : '50px',
              }}
            >
              {slide}
            </InfoCard>
          ))}
        </Carousel>
      </Box>
    </div>
  );
};

export default CarouselViewer;
